import { URL, COMPANY_NAME_KO, COMPANY_NAME_EN } from '../../utils/Utils'
import IMG_1 from 'assets/images/gogoro-network/1.png'
import IMG_2 from 'assets/images/gogoro-network/2.png'
import IMG_3 from 'assets/images/gogoro-network/3.png'
import IMG_4 from 'assets/images/gogoro-network/4.png'
import IMG_7 from 'assets/images/gogoro-network/station_img.png'
import ICON_1 from 'assets/images/gogoro-network/v1.png'
import ICON_2 from 'assets/images/gogoro-network/v2.png'
import ICON_3 from 'assets/images/gogoro-network/v3.png'
import ICON_4 from 'assets/images/gogoro-network/v4.png'
import Map from '../../components/Map'
import './NetworkMain.scss'
import MapMain from 'pages/map/MapMain'

/**
 * @file 고고로 네트워크 main 화면
 */
function NetworkMain() {
    return (
        <>
            <div className="network-one" style={{ backgroundImage: `url(${IMG_1})` }}>
                <div className="text-box">
                    <div className="t1">
                        {COMPANY_NAME_KO}의 스왑 네트워크는
                        <br />
                        오늘보다 내일 더 스마트합니다.
                    </div>
                    <div className="sub">
                        Gogoro Network® Smart Battery Swap Platform을 사용하면
                        <br />
                        Gogoro Smartscooter®를 더 빠르고 쉽고
                        <br />
                        스마트하게 충전할 수 있습니다.
                    </div>
                </div>
            </div>

            <>
                <div className="network-two">
                    <div className="network-map-wrap">
                        <div className="text-box">
                            <div className="t1">스왑스테이션 네트워크 검색</div>
                            <div className="sub">스왑스테이션의 위치를 확인해보세요.</div>
                        </div>
                        <MapMain isNewPage={false} />
                        {/* <Map initSearchType={3} isNewPage={false} /> */}
                    </div>
                    <div className="network-stationInfo-wrap">
                        <div className="text-box">
                            <div className="t1">압도적인 스왑 스테이션 성능</div>
                        </div>
                        <div className="text-gray-box-wrap">
                            <div className="text-gray-box">
                                <div className="text-gray-box-t1">최대 14대 동시커버 가능</div>
                                <div className="text-gray-box-sub">단 1대로 타사 스테이션 4~5대의 효과</div>
                            </div>
                            <div className="text-gray-box">
                                <div className="text-gray-box-t1">배터리 교환 시간</div>
                                <div className="text-gray-box-sub">6초- 15초</div>
                            </div>
                        </div>
                    </div>
                </div>
                <img src={IMG_7} alt="스왑스테이션 이미지" className="network-swap-img" />
            </>
            <div className="network-three">
                <div>
                    <div className="t1">Swap &amp; Go</div>
                    <div className="sub">
                        당신의 시간을 아껴줄
                        <br />
                        {COMPANY_NAME_EN}의 배터리 스왑 네트워크
                    </div>
                    <img src={IMG_2} alt="1번 이미지" />
                </div>
                <div>
                    <div className="t1">제약 없는 주행</div>
                    <div className="sub">
                        외출할 때 배터리를 확인하지 않아도
                        <br />
                        배터리 스왑 네트워크라면
                        <br />
                        걱정할 필요가 없습니다.
                    </div>
                    <img src={IMG_3} alt="2번 이미지" />
                </div>
                <div>
                    <div className="t1">배터리 스왑 서비스</div>
                    <div className="sub">
                        배터리 스왑 서비스를 통해
                        <br />
                        차량의 배터리 성능을 <br />
                        항상 최상으로 유지합니다.
                    </div>
                    <img src={IMG_4} alt="3번 이미지" />
                </div>
            </div>

            <div className="network-four">
                <div className="t1">
                    배터리 성능은
                    <br />
                    계속 업그레이드됩니다.
                </div>
                <div className="sub">
                    Gogoro Network의 배터리 성능은 꾸준히 업그레이드되고 있으며, 주행 가능거리 또한 점진적으로
                    향상됩니다.
                </div>
                <div className="describes-wrap">
                    <div className="describes-row">
                        <div>
                            <img src={ICON_1} alt="1번 아이콘" />
                            <div className="t1">슈퍼 세이프</div>
                            <div className="sub">
                                견고한 방수 알루미늄 합금 케이스에 들어있어 뛰어난 안전성을 자랑합니다.
                            </div>
                        </div>
                        <div>
                            <img src={ICON_2} alt="2번 아이콘" />
                            <div className="t1">감가상각, 유지보수 걱정없이</div>
                            <div className="sub">
                                주행 효율에 영향을 미치는 배터리 감가상각이나 배터리 관리 비용을 걱정할 필요가 없습니다.
                            </div>
                        </div>
                    </div>
                    <div className="describes-row">
                        <div>
                            <img src={ICON_3} alt="3번 아이콘" />
                            <div className="t1">스마트 배터리</div>
                            <div className="sub">
                                모든 배터리는 스마트 네트워크를 통해 관리되어 항상 가장 좋은 상태의 배터리를 제공합니다.
                            </div>
                        </div>
                        <div>
                            <img src={ICON_4} alt="4번 아이콘" />
                            <div className="t1">더욱 스마트하게</div>
                            <div className="sub">
                                배터리는 스마트 스쿠터와 동기화되어 에너지 사용 내역, 차량 상태 등 모든 정보를 추적할 수
                                있습니다.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NetworkMain
